<template>
  <div id="HeaderPage">     
      <v-row>
        <v-col cols="12" sm="12" md="8" lg="8" xl="8" >  
          <h4 class="breadcrumbs-title">{{breadcrumbs.title}}</h4>
          <h6 class="breadcrumbs-title">{{breadcrumbs.description}}</h6>         
          <v-divider/>                             
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="4" xl="4" >  
            <br><br>
            <v-text-field
                      v-if="hasInputWord"
                      v-model="sword"
                      hide-details
                      prepend-icon="mdi-magnify"
                      single-line        
                      placeholder="buscar..."
                      v-on:keyup.13="getWord(sword)"
                      autofocus
            ></v-text-field>
        </v-col>
      </v-row>         
        
  </div>
</template>

<script>
import{ mapState } from "vuex";

export default {
  name: "HeaderPage",
  computed:{
    ...mapState(['breadcrumbs']),
  },
  methods:{    
    getWord(valor){
      this.$emit('sword-id', valor);
      // alert(valor)
    }
  },
  props: {    
    hasInputWord:String,
  },
  data() {
    return {
      sword:'All'
    };
  }
};
</script>